import type { Set } from '@/types/set';
import Badge from '@/components/common/Badge';

interface SetListItemProps {
  set: Set;
  onClick: () => void;
}

export default function SetListItem({ set, onClick }: SetListItemProps) {
  return (
    <button
      onClick={onClick}
      className="w-full border-b border-neutral-100 px-4 py-3 text-left transition-colors hover:bg-neutral-50"
    >
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-medium text-neutral-900">{set.name}</h3>
        {set.is_default && (
          <Badge variant="default">Default</Badge>
        )}
      </div>
      {set.description && (
        <p className="mt-1 text-xs text-neutral-500 line-clamp-1">{set.description}</p>
      )}
    </button>
  );
}
